import resolveConfig from 'tailwindcss/resolveConfig';
import tailwindConfig from '../../../tailwind.config';
const { theme } = resolveConfig(tailwindConfig);
const borderRadiusClasses = Object.keys(theme.borderRadius).map((size) => `rounded-${size}`);
const borderWidthClasses = Object.keys(theme.borderWidth).map((size) => `border-${size}`);
/**
 * This object should only be used within the customTV !
 *
 * @see customTV
 */
export const borderRadiusClassesConfig = {
    'border-radius': [...borderRadiusClasses],
};
export const borderWidthClassesConfig = {
    'border-width': [...borderWidthClasses],
};
